import React, { useState } from "react";
// import Table from "../../../components/Table";
import RiskIcon from "../../../assets/svg/icons/common/risk";
import styles from "./styles.module.scss";
import DeleteMCC from "./delete-modal";
import ReactPaginate from "react-paginate";
import AddAndEditMCC from "../add-and-edit-modal";
import BulkAction from "./bulk-action";
import Pagination from "../../../components/Pagination/Pagination";
import Checkbox from "../../../components/Checkbox/Index";
import WarningIcon from '../../../assets/svg/icons/common/Warning';
import Table from './table';
import useMccStore from "../../../stores/mcc";

const List = ({
  setPage,
  getMCCList,
  page,
  pageCount
}) => {
  const mccList = useMccStore((state) => state.mccList);
  const selectedMcc = useMccStore((state) => state.selectedMcc);
  const totalItems = useMccStore((state) => state.totalItems);
  const itemsPerPage = useMccStore((state) => state.itemsPerPage);
  const handlePage = (pageValue) => {
    setPage(pageValue.selected + 1);
  };

  return (
    <div className={styles.card}>
      <div>
        <Table
          data={mccList}
          fetchData={getMCCList}
        />
        <div className={styles.pagination}>
          <Pagination
            pageCount={pageCount}
            currentPage={page - 1}
            onPageChange={handlePage}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
          />
        </div>
      </div>
      {!!selectedMcc.length && <BulkAction
        fetchData={getMCCList}
      />}
    </div>
  );
};

export default List;
